import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useRef, useState, useEffect } from 'react';
import { Row, Col, Table, Dropdown, Button, useIsMounted, useUser, Paper, showSuccess } from 'components';
import { showApiError, convertToAdditionalCurrency } from 'utils';
import { getAllPartnerFunds, getAllPartners, getPartnerFundsBalance, postCommissionReport } from 'services';
import { ROLES } from 'enums';
import { tableWrap } from 'styles';
import { partnerFundsColumns } from './config';
import { tableHeaderContainer, balanceContainer, balanceItem, balanceLabel, balanceValue } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var CashDeskTab = function CashDeskTab() {
  var _balance$commission_r, _balance$available_ba, _balance$profit_balan;

  var _useUser = useUser(),
      userInfo = _useUser.userInfo;

  var isPartner = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_role) === ROLES.partner;
  var tableRef = useRef();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPartner = _useState2[0],
      setSelectedPartner = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      partners = _useState4[0],
      setPartners = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      balance = _useState6[0],
      setBalance = _useState6[1];

  var isMounted = useIsMounted();
  useEffect(function () {
    fetchPartners();
  }, []);
  useEffect(function () {
    if (isMounted.current && selectedPartner) {
      var _tableRef$current;

      fetchBalance();
      (_tableRef$current = tableRef.current) === null || _tableRef$current === void 0 ? void 0 : _tableRef$current.getData({
        partner: selectedPartner
      });
    }
  }, [selectedPartner]);

  var fetchBalance = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getPartnerFund, _yield$getPartnerFund2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (selectedPartner) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return getPartnerFundsBalance({
                partner_id: selectedPartner
              });

            case 4:
              _yield$getPartnerFund = _context.sent;
              _yield$getPartnerFund2 = _slicedToArray(_yield$getPartnerFund, 2);
              res = _yield$getPartnerFund2[0];
              err = _yield$getPartnerFund2[1];

              if (!err) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 10:
              setBalance(res);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchBalance() {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchPartners = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _res$0$id, _res$;

      var _userInfo$partners$0$, _userInfo$partners$, _yield$getAllPartners, _yield$getAllPartners2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(userInfo !== null && userInfo !== void 0 && userInfo.partners && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.partners.length) > 0)) {
                _context2.next = 4;
                break;
              }

              setPartners(userInfo === null || userInfo === void 0 ? void 0 : userInfo.partners);
              setSelectedPartner((_userInfo$partners$0$ = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$partners$ = userInfo.partners[0]) === null || _userInfo$partners$ === void 0 ? void 0 : _userInfo$partners$.id) !== null && _userInfo$partners$0$ !== void 0 ? _userInfo$partners$0$ : null);
              return _context2.abrupt("return");

            case 4:
              _context2.next = 6;
              return getAllPartners();

            case 6:
              _yield$getAllPartners = _context2.sent;
              _yield$getAllPartners2 = _slicedToArray(_yield$getAllPartners, 2);
              res = _yield$getAllPartners2[0];
              err = _yield$getAllPartners2[1];

              if (!err) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 12:
              setPartners(res);
              setSelectedPartner((_res$0$id = (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : _res$.id) !== null && _res$0$id !== void 0 ? _res$0$id : null);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchPartners() {
      return _ref2.apply(this, arguments);
    };
  }();

  var fetchPartnerFunds = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(tableOptions) {
      var _yield$getAllPartnerF, _yield$getAllPartnerF2, res, err;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (tableOptions.partner) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", [{
                data: [],
                total: 0
              }, null]);

            case 2:
              _context3.next = 4;
              return getAllPartnerFunds(tableOptions);

            case 4:
              _yield$getAllPartnerF = _context3.sent;
              _yield$getAllPartnerF2 = _slicedToArray(_yield$getAllPartnerF, 2);
              res = _yield$getAllPartnerF2[0];
              err = _yield$getAllPartnerF2[1];

              if (!err) {
                _context3.next = 11;
                break;
              }

              showApiError(err);
              return _context3.abrupt("return", [null, err]);

            case 11:
              return _context3.abrupt("return", [res, null]);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function fetchPartnerFunds(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handlePartnerChange = function handlePartnerChange(value) {
    setSelectedPartner(value);
    setBalance(null);
  };

  var handleCommissionReport = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _tableRef$current2;

      var _yield$postCommission, _yield$postCommission2, err;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return postCommissionReport({
                partner: selectedPartner,
                user: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id,
                amount: balance === null || balance === void 0 ? void 0 : balance.commission_report_balance
              });

            case 2:
              _yield$postCommission = _context4.sent;
              _yield$postCommission2 = _slicedToArray(_yield$postCommission, 2);
              err = _yield$postCommission2[1];

              if (!err) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt("return", showApiError(err));

            case 7:
              showSuccess('Таксите са отчетени успешно!');
              fetchBalance();
              (_tableRef$current2 = tableRef.current) === null || _tableRef$current2 === void 0 ? void 0 : _tableRef$current2.getData({
                partner: selectedPartner
              });

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleCommissionReport() {
      return _ref4.apply(this, arguments);
    };
  }();

  var filterBar = function filterBar() {
    return ___EmotionJSX("section", {
      css: tableHeaderContainer
    }, ___EmotionJSX(Row, {
      horizontalGap: 16,
      verticalGap: 8
    }, ___EmotionJSX(Col, {
      sm: 12,
      md: 4
    }, ___EmotionJSX(Dropdown, {
      small: true,
      withSearch: true,
      placeholder: "\u041F\u0430\u0440\u0442\u043D\u044C\u043E\u0440 *",
      displayKey: "name",
      uniqueKey: "id",
      value: selectedPartner,
      options: partners,
      onChange: handlePartnerChange,
      mapValue: function mapValue(val) {
        return val === null || val === void 0 ? void 0 : val.id;
      }
    })), !selectedPartner && ___EmotionJSX(Col, {
      sm: 12,
      md: 8,
      displayFlex: true,
      align: "center"
    }, ___EmotionJSX("p", {
      style: {
        color: '#666',
        fontStyle: 'italic'
      }
    }, "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043F\u0430\u0440\u0442\u043D\u044C\u043E\u0440"))));
  };

  return ___EmotionJSX(React.Fragment, null, selectedPartner && balance && ___EmotionJSX(Paper, {
    margin: "0 2em 1em 2em"
  }, ___EmotionJSX("div", {
    css: balanceContainer
  }, ___EmotionJSX("div", {
    css: balanceItem
  }, ___EmotionJSX("span", {
    css: balanceLabel
  }, "\u0421\u044A\u0431\u0440\u0430\u043D\u0438 \u043D\u0435\u043E\u0442\u0447\u0435\u0442\u0435\u043D\u0438 \u0442\u0430\u043A\u0441\u0438 \u0414\u041F:"), ___EmotionJSX("div", {
    css: balanceValue
  }, ___EmotionJSX("span", null, (_balance$commission_r = balance === null || balance === void 0 ? void 0 : balance.commission_report_balance) !== null && _balance$commission_r !== void 0 ? _balance$commission_r : 0, " ", balance === null || balance === void 0 ? void 0 : balance.currency), ___EmotionJSX("span", null, convertToAdditionalCurrency({
    value: balance === null || balance === void 0 ? void 0 : balance.commission_report_balance,
    fromCurrency: balance === null || balance === void 0 ? void 0 : balance.currency
  })))), ___EmotionJSX("div", {
    css: balanceItem
  }, ___EmotionJSX("span", {
    css: balanceLabel
  }, "\u0421\u044A\u0431\u0440\u0430\u043D\u0438 \u043D\u0435\u043E\u0442\u0447\u0435\u0442\u0435\u043D\u0438 \u043F\u043B\u0430\u0449\u0430\u043D\u0438\u044F \u043F\u043E \u0433\u043B\u0430\u0432\u043D\u0438\u0446\u0438 \u0438 \u043B\u0438\u0445\u0432\u0438:"), ___EmotionJSX("div", {
    css: balanceValue
  }, ___EmotionJSX("span", null, (_balance$available_ba = balance === null || balance === void 0 ? void 0 : balance.available_balance) !== null && _balance$available_ba !== void 0 ? _balance$available_ba : 0, " ", balance === null || balance === void 0 ? void 0 : balance.currency), ___EmotionJSX("span", null, convertToAdditionalCurrency({
    value: balance === null || balance === void 0 ? void 0 : balance.available_balance,
    fromCurrency: balance === null || balance === void 0 ? void 0 : balance.currency
  })))), ___EmotionJSX("div", {
    css: balanceItem
  }, ___EmotionJSX("span", {
    css: balanceLabel
  }, "\u041F\u0435\u0447\u0430\u043B\u0431\u0430 \u0414\u041F \u0441\u043B\u0435\u0434 \u043E\u0442\u0447\u0435\u0442"), ___EmotionJSX("div", {
    css: balanceValue
  }, ___EmotionJSX("span", null, (_balance$profit_balan = balance === null || balance === void 0 ? void 0 : balance.profit_balance) !== null && _balance$profit_balan !== void 0 ? _balance$profit_balan : 0, " ", balance === null || balance === void 0 ? void 0 : balance.currency), ___EmotionJSX("span", null, convertToAdditionalCurrency({
    value: balance === null || balance === void 0 ? void 0 : balance.profit_balance,
    fromCurrency: balance === null || balance === void 0 ? void 0 : balance.currency
  }))))), isPartner && (balance === null || balance === void 0 ? void 0 : balance.commission_report_balance) > 0 && ___EmotionJSX(Row, {
    margin: "1em 0 0 0"
  }, ___EmotionJSX(Col, null, ___EmotionJSX(Button, {
    type: "primary",
    onClick: handleCommissionReport
  }, "\u041E\u0442\u0447\u0435\u0442\u0438 \u0442\u0430\u043A\u0441\u0438 \u0414\u041F \u043D\u0430 \u043F\u0430\u0440\u0442\u043D\u044C\u043E\u0440\u0430")))), ___EmotionJSX("div", {
    css: tableWrap
  }, ___EmotionJSX(Table, {
    hasPagination: true,
    ref: tableRef,
    getDataMethod: fetchPartnerFunds,
    columns: partnerFundsColumns(),
    emptyMessage: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F \u0437\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438\u044F \u043F\u0430\u0440\u0442\u043D\u044C\u043E\u0440",
    filterBar: filterBar,
    margin: "0 2em",
    pageSize: 20
  })));
};

export default CashDeskTab;